import "./resourceUpdateAll.css";
import React, { useState, useEffect, useRef } from "react";
import { ErrorPopover } from "../../../common/ErrorPopover/errorPopover";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { rescgetStakeholderType } from "./resourceUpdateApi";
import { DialogContent, Dialog, DialogActions, Button } from '@mui/material';
import { PROD } from "../../../common/constants";
import { Container, Stack, Typography, Grid, FormHelperText, FormControl, TextField } from '@mui/material';
import { toast } from 'react-toastify';
import { SubmitIcon } from "../../../common/icons";

function SearchResourceUpdateURN() {
   const navigate = useNavigate();
   const [logModalOpen, setLogModalOpen] = useState(false);
   const handleLogModalOpen = () => setLogModalOpen(true);
   const handleLogModalClose = () => setLogModalOpen(false);
   const [logModalOpen1, setLogModalOpen1] = useState(false);
   const handleLogModalOpen1 = () => setLogModalOpen1(true);
   const handleLogModalClose1 = () => setLogModalOpen1(false);
   const [details, setDetails] = useState({
      "urn": ""
   });

   const [errorMessage, setErrorMessage] = useState({
      urnError: "",

   })
   const [getCategoryType, setGetCategoryType] = useState('');
   const handleChange = (e) => {
      setDetails({
         ...details,
         [e.target.name]: e.target.value,
      });
      if (e.target.name === "urn") {
         setErrorMessage({ ...errorMessage, urnError: "" });
      }
   };
   const userlog = useRef(true);
   useEffect(() => {
      userlog.current = false;
      //console.log(getCategoryType)
      if (getCategoryType.stakeHolder && getCategoryType.stakeHolder?.registrationStatus === "Approved") {
         if (getCategoryType.stakeHolder.categoryName == "Transporter") {
            navigate("registrationDetailsTransporter", { state: { URN: details.urn } })
         }
         else if (getCategoryType.stakeHolder.categoryName == "HIT") {
            navigate("registrationDetailsHit", { state: { URN: details.urn } })
         }
         else if (getCategoryType.stakeHolder.categoryName == "LLE") {
            navigate("registrationDetailsLle", { state: { URN: details.urn } })
         }
          else if (getCategoryType.stakeHolder.categoryName == "Grower" || getCategoryType.stakeHolder.categoryName == "Individual" || getCategoryType.stakeHolder.categoryName == "JFMC" || getCategoryType.stakeHolder.categoryName === "Other Agency") {
            if (getCategoryType.stakeHolder.growerMasters[0].growerType === "Co-operative" || getCategoryType.stakeHolder.growerMasters[0].growerType === "FPO" || getCategoryType.stakeHolder.growerMasters[0].growerType === "SHG" || getCategoryType.stakeHolder.growerMasters[0].growerType === "FPC") {
               navigate("registrationMemberDetails", { state: { URN: details.urn, stakeHolderSubCategory: getCategoryType.stakeHolder.growerMasters[0].growerType } })
            }
            else if (getCategoryType.stakeHolder.growerMasters[0].growerType === "Forest") {
               navigate("registrationDetailsForest", { state: { URN: details.urn } })
            }
            else {
               navigate("registrationDetails", { state: { URN: details.urn } });
            }
         }
         else if (getCategoryType.stakeHolder.categoryName == "HIT") {
            navigate("hitRegistration", { state: { URN: details.urn } });
         }
         else if (getCategoryType.stakeHolder.categoryName == "LLE") {
            navigate("lleMainPage", { state: { URN: details.urn } })
         }
         else if (getCategoryType.stakeHolder.categoryName == "Interim Storage Operator") {
            navigate("registrationDetailsTempStorage", { state: { isPreReg: false, URN: details.urn } })
         }
      }
      else {
         if (getCategoryType.message) {
            if(getCategoryType.stakeHolder && getCategoryType.stakeHolder?.registrationStatus !== "Approved") {
               toast.error("Stakeholder not approved");
            }
            else {
               toast.error("Enter Valid URN");
            }
            setGetCategoryType('')
         }
      }
   }, [userlog, getCategoryType, details]);
   const onSubmit = (e) => {
      e.preventDefault();
      const userData = {
         urn: details.urn,
      };
      if (!details.urn) {
         toast.error("Enter Valid URN");
      } else {
         rescgetStakeholderType(userData.urn, setGetCategoryType)
      }
   }
   return (
      <>
         <Container maxWidth="xxl">
            {!PROD && <p className='pageNumberingResc'>RES10</p>}
            <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
               <Typography variant="h5" gutterBottom>
                  Enter Valid URN For Resource Update
               </Typography>
            </Stack>
            <Grid container spacing={1}>
               <Grid item xs={12} lg={3}>
                  <FormControl sx={{ width: '100%', paddingRight: '3%' }}>
                     <TextField fullWidth
                        label="URN"
                        name="urn"
                        placeholder="e.g. URN-KAKGR00123"
                        onChange={(e) => handleChange(e)}
                        sx={{ paddingRight: '3%', mt: 2, bgcolor: 'white' }}
                     />
                     
                  </FormControl>
               </Grid>
               <Grid item xs={12} lg={3}>
                  <Button endIcon={<SubmitIcon />} sx={{ minWidth: 100, mt: 3 }} variant="contained" onClick={(e) => onSubmit(e)}>Submit</Button>
               </Grid>
            </Grid>
         </Container>
         <Dialog maxWidth='xs' fullWidth open={logModalOpen}>
            <DialogContent>
               <ErrorPopover title={"Enter Valid URN"} />
            </DialogContent>
            <DialogActions>
               <Button onClick={handleLogModalClose}>OK</Button>
            </DialogActions>
         </Dialog>
         <Dialog maxWidth='xs' fullWidth open={logModalOpen1}>
            <DialogContent>
               <ErrorPopover title={"Enter Valid URN"} />
            </DialogContent>
            <DialogActions>
               <Button onClick={handleLogModalClose1}>OK</Button>
            </DialogActions>
         </Dialog>
      </>
   );
}
export default SearchResourceUpdateURN;
